import { lazy } from 'react'
import { observer } from 'mobx-react'
import { Route, Routes } from 'react-router-dom'
import DomainPage from 'pages/DomainPage'
import routes from 'routes'

const SignUpPage = lazy(() => import('pages/SignUpPage'))

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<DomainPage />} />
      <Route path={routes.signUp.value} element={<SignUpPage />} />
      <Route path="*" element={<div>Public 404</div>} /> {/* Public-specific 404 */}
    </Routes>
  )
}

export default observer(PublicRoutes)
